/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which UUID versions are recognized?`)
};

const es_ud_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué versiones de UUID se reconocen?`)
};

const de_ud_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche UUID-Versionen werden erkannt?`)
};

const nl_ud_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke UUID-versies worden herkend?`)
};

const fr_ud_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles versions d'UUID sont reconnues ?`)
};

const it_ud_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali versioni di UUID vengono riconosciute?`)
};

const pt_br2_ud_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais versões de UUID são reconhecidas?`)
};

const pt_ud_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que versões de UUID são reconhecidas?`)
};

const ja_ud_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの UUID バージョンが認識されますか?`)
};

const zh_ud_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持识别哪些 UUID 版本?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_faq1_q", locale)
	if (locale === "en") return en_ud_faq1_q(inputs)
	if (locale === "es") return es_ud_faq1_q(inputs)
	if (locale === "de") return de_ud_faq1_q(inputs)
	if (locale === "nl") return nl_ud_faq1_q(inputs)
	if (locale === "fr") return fr_ud_faq1_q(inputs)
	if (locale === "it") return it_ud_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_ud_faq1_q(inputs)
	if (locale === "pt") return pt_ud_faq1_q(inputs)
	if (locale === "ja") return ja_ud_faq1_q(inputs)
	return zh_ud_faq1_q(inputs)
};